import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from "rxjs/operators";
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from "rxjs";
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { DialogService } from 'src/app/shared/services/dialog.service';

interface instructor {
  cantCursos: number
  cantVentas: number
  categorias: string[],
  creador: string,
  descripcion: string,
  email: string,
  empresaDescripcion: string,
  empresaFoto: string,
  empresaId: string,
  empresaNombre: string,
  empresaResumen: string,
  enlaceLinkedin: string,
  fechaCreacion: Date,
  firma: string,
  foto: string,
  fotoFondo: string,
  nombre: string,
  porcentaje: number,
  publicado: boolean,
  resumen: string,
  sitioWeb: string,
  ultimaEdicion: Date,
  ultimoEditor: string,
  usuarioInstructorId: string,
}

interface empresa {
  id: string,
  nombre: string,
  descripcion: string,
  foto: string,
  resumen: string,
}

@Component({
  selector: 'app-form-instructor',
  templateUrl: './form-instructor.component.html',
  styleUrls: ['./form-instructor.component.css']
})
export class FormInstructorComponent implements OnInit {

  constructor(
    private shared: RoutingVariablesService,
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
    private storage: AngularFireStorage,
  ) { }

  //spinner
  loaded = 0

  // Si vamos a editar entonces debe tener un id en la ruta
  id = this.route.snapshot.paramMap.get('id');

  empresa: empresa = {
    id: '',
    nombre: '',
    descripcion: '',
    foto: '',
    resumen: '',
  }

  empresas: empresa[] = []

  instructor: instructor = {
    cantCursos: 0,
    cantVentas: 0,
    categorias: [],
    creador: '',
    descripcion: '',
    email: '',
    empresaDescripcion: '',
    empresaFoto: '',
    empresaId: '',
    empresaNombre: '',
    empresaResumen: '',
    enlaceLinkedin: '',
    fechaCreacion: new Date,
    firma: '',
    foto: '',
    fotoFondo: '',
    nombre: '',
    porcentaje: 0,
    publicado: true,
    resumen: '',
    sitioWeb: '',
    ultimaEdicion: new Date,
    ultimoEditor: '',
    usuarioInstructorId: '',
  }

  // auxiliares para cargar fotos
  downloadURL: any;
  fire: any;
  
  // FLAG
  editar = 0;
  usuario = JSON.parse(localStorage.getItem('user'))

  ngOnInit(): void {
    this.verificarEdicionOCreacion();
  }

  verificarEdicionOCreacion() {
    this.cargarEmpresas();
    if (this.id == null) {
      this.inicializarCrearInstructor();
    } else {
      this.inicializarEditarInstructor();
    }
  }

  // INICIALIZACION DE CREAR INSTRUCTOR

  inicializarCrearInstructor() {
    this.editar = 0;
    this.loaded = 1;
  }

  /// INICIALIZACION DE EDICION DE Instructor //

  inicializarEditarInstructor() {
    this.editar = 1
    this.cargarInstructor();
  }

  cargarInstructor() {
    this.afs.collection('instructores').doc(this.id).ref.get().then(doc => {
      const instructor = doc.data();
      this.instructor = {
        cantCursos: instructor['cantCursos'], //
        cantVentas: instructor['cantVentas'], //
        categorias: instructor['categorias'],
        creador: instructor['creador'],
        descripcion: instructor['descripcion'],
        email: instructor['email'], //
        empresaDescripcion: instructor['empresaDescripcion'],
        empresaFoto: instructor['empresaFoto'],
        empresaId: instructor['empresaId'],
        empresaNombre: instructor['empresaNombre'],
        empresaResumen: instructor['empresaResumen'],
        enlaceLinkedin: instructor['enlaceLinkedin'],
        fechaCreacion: instructor['fechaCreacion'],
        foto: instructor['foto'], //
        firma: instructor['firma'], //
        fotoFondo: instructor['fotoFondo'],
        nombre: instructor['nombre'],
        porcentaje: instructor['porcentaje'],
        publicado: instructor['publicado'],
        resumen: instructor['resumen'],
        sitioWeb: instructor['sitioWeb'],
        ultimaEdicion: instructor['ultimaEdicion'],
        ultimoEditor: instructor['ultimoEditor'],
        usuarioInstructorId: instructor['usuarioInstructorId'],
      }
      this.loaded = 1;
    }).catch(error => {
      console.log(error)
    });
  }

  /// FUNCIONALIDADES ///////////////////////////////

  // Armar array de empresas

  cargarEmpresas() {
    this.afs.collection('empresas').ref.get().then(response => {
      response.docs.forEach(doc => {
        const data = doc.data();
        const empresa: empresa = {
          id: doc.id,
          nombre: data['nombre'],
          foto: data['foto'],
          descripcion: data['descripcion'],
          resumen: data['resumen']
        }
        this.empresas = this.empresas.concat(empresa) //Se debe igualar. De lo contrario no se guarda -a diferencia del push-

      })
    }).then(() => {
      const idx = this.empresas.findIndex(x => x.id == this.instructor.empresaId)
      this.empresa = this.empresas[idx];
    }).catch(error => {
      console.log(error)
    })
  }

  cargarFoto(event, campo) {
    const file = event.target.files[0];
    let nombre: string = file.name;
    nombre = nombre.replace(' ','-');
    const filePath = `Instructores/${this.id}/${nombre}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`Instructores/${this.id}/${nombre}`, file);
    task
      .snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) { this.fire = url; }
            console.log(this.fire)
            if (campo == "foto") {
              this.instructor.foto = url;
            }
            if (campo == "firma") {
              this.instructor.firma = url;
            }
            if (campo == "fotoFondo") {
              this.instructor.fotoFondo = url;
            }
          });
        })
      )
      .subscribe(url => {
        if (url) {
          console.log(url);
        }
      });
  }

  cambiaEmpresa() {
    const idx = this.empresas.findIndex(x => x.id == this.instructor.empresaId)
    this.empresa = this.empresas[idx];
    this.instructor.empresaId = this.empresa.id;
    this.instructor.empresaNombre = this.empresa.nombre;
    this.instructor.empresaFoto = this.empresa.foto;
    this.instructor.empresaResumen = this.empresa.resumen;
    this.instructor.empresaDescripcion = this.empresa.descripcion;
  }

  guardarInstructor() {
    if (this.editar == 0) {
      this.id = this.instructor.nombre.split(' ').join('-');
      this.instructor.creador = this.usuario.uid;
      this.instructor.fechaCreacion = new Date();
    }
    this.instructor.ultimaEdicion = new Date();
    this.instructor.ultimoEditor = this.usuario.uid;

    this.afs.collection('instructores').doc(this.id).set(this.instructor, { merge: true }).then(() => {
      this.dialogService.dialogExito().afterClosed().subscribe(res => {
        this.router.navigate(['admin/lista-instructores']);
      })
    }).catch(error => {
      this.dialogService.dialogFracaso()
      console.log(error)
    })
  }

  onDelete() {
    this.dialogService.dialogConfirmar().afterClosed().subscribe(res => {
      if (res == true) {
        this.afs.collection('instructores').doc(this.id).delete().then(() => {
          this.dialogService.dialogExito().afterClosed().subscribe(res => {
            this.router.navigate(['admin/lista-instructores']);
          })
        }).catch(error => {
          this.dialogService.dialogFracaso()
          console.log(error)
        });
      }
    });
  }

}
